import { Component, AfterViewInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SheetComponent } from '../../../../shared/ui';

@Component({
    selector: 'input-filter-sheet',
    template: require('./input-filter-sheet.component.pug')
})
export class InputFilterSheetComponent implements AfterViewInit {
     @Input() fg: FormGroup;
     @Input() placeholder: string;
     @Output() applyChanges = new EventEmitter();

    @ViewChild(SheetComponent) sheet;
    constructor() {}

    ngAfterViewInit() {
        this.fg.controls['filter'].valueChanges
             .debounceTime(50)
             .subscribe(value => this.onApplyClicked(value));
    }

    toggle() {
        this.sheet.toggle();
    }

    onApplyClicked(filter: string) {
       this.applyChanges.emit(filter);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/inventory/shared/ui/input-filter-sheet/input-filter-sheet.component.ts